<template>
  <div class="pageError">
    <section class="page">
      <div class="error">
        <h1>Sorry, this page does not exist.</h1>
        <p>
          Return to
          <router-link :to="{ name: 'Dashboard' }">Dashboard</router-link>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
}
</script>
